export default __webpack_public_path__ + "static/media/MetaverseThumbnail.77323079.png";